export default __webpack_public_path__ + "7036d4f8f140533c71fe481079297ad0.png";